module.exports = __webpack_public_path__ + "static/trailers_thumbnail-11824dff5c880478d31edb139601ed2b.png";